import { Box, Button, Stack } from "@mui/material";
import LogChat from "./LogChat";
import PlaningToolRoot, { State } from "../PlaningToolRoot";
import { MItem } from "../Menu";
import InputB from "../../../components/InputB/InputB";
import { useState } from "react";
import { GLItemKind, GLItemStatus, GLItemStatuses } from "../../../DTO/GLItemDTO";
import { Help } from "../Help";
import LogChatAmountDisplay from "./LogChatAmountDisplay";
import LogChatDetail from "./LogChatDetail";
import mainservice from "../../../services/MainService";


export default function LogChatCenter(props: {
  standalone?: boolean,
  className?: string,
  headline?: string,
  kind?: GLItemKind,
  menuItem?: MItem,
  useAlarmButton?: boolean,
  usePersonButton?: boolean,
}) {
  const [needle, setNeedle] = useState('')
  const [statusTab, setStatusTab] = useState<GLItemStatus | undefined>(GLItemStatus.generic)
  const [chatDetailId, setChatDetailId] = useState<number>(-1)
  const [userId, setUserId] = useState<number>(-1)
  const [pastduedate, setPastDueDate] = useState<boolean>(false)
  const onAlarmButton = props.useAlarmButton ? () => {
      setPastDueDate(!pastduedate)
  } : undefined
  const onPersonButton = props.usePersonButton ? () => {
      if (userId === -1) {
        setUserId(mainservice.getUserId())
      } else {
        setUserId(-1)
      }
  } : undefined
  const className = `LogChatCenter flex flex-column ${props.className || ''}`
  console.log('right id', chatDetailId)
  return <PlaningToolRoot
      standalone={true}
      menuItem={props.menuItem === undefined ? MItem.logChat : props.menuItem}
      mainContentClass={className}
      rightDrawer={<LogChatDetail
        id={chatDetailId}
        onClose={() => setChatDetailId(-1)}
      />}
      startStateRightDrawer={chatDetailId > -1 ? State.open : State.closed}
    >
      <div className='contentHeader'>
        <h2>{props.headline || 'Central Log'}</h2>
        <Stack
          spacing={2}
        >
          <Stack
            direction='row'
            spacing={2}
          >
            <InputB
              className='flex-grow'
              returnVal={async (val) => {
                setNeedle(val)
              }}
              placeholder={'Suchen...'}
              value={needle}
              clearButton={true}
              sendButton="Suchen"
              delay={-1}
            />
            <Help>
              <h2>Suchfunktionen im Überblick</h2>
              <div>Einfach tippen und ein paar Sekunden warten. Dann werden automatisch die passenden Ergebnisse geladen.</div>
              <h3>Sonderfunktionen:</h3>
              <ul>
              <li><strong>@</strong>: Ort - Verwende dieses Präfix, um nach einem Ort des Unternehmens zu suchen</li>
              <li><strong>%</strong>: Unternehmen - Verwende dieses Präfix, um nach einem Unternehmen zu suchen</li>
              </ul>
            </Help>
          </Stack>
          {
            props.kind !== undefined && GLItemStatuses[props.kind].length > 0 && 
            <Stack
              direction={'row'}
              spacing={2}
              useFlexGap
              sx={{
                flexWrap: 'wrap',
              }}
            >
              {GLItemStatuses[props.kind].map(s => {
                if ((s as {hideInTabs?: boolean}).hideInTabs) {
                  return null
                }
                return <Button
                  key={`logchat-status-tab-${s.status}`}
                  variant={s.status === statusTab ? 'contained' : 'outlined'}
                  onClick={() => setStatusTab(s.status)}>{s.name} <LogChatAmountDisplay
                    kind={props.kind}
                    status={s.status}
                    userId={userId}
                    pastduedate={pastduedate}
                  /></Button>
                })}
            </Stack>
          }
        </Stack>
      </div>
      <Box
        sx={{
          padding: 2,
          backgroundColor: 'white',
        }}
      >
        <LogChat
            disableNewMsg
            needle={needle}
            kind={props.kind}
            statusKind={statusTab}
            onClickDetail={(id) => setChatDetailId(id)}
            markedId={chatDetailId}
            onAlarmButton={onAlarmButton}
            onPersonButton={onPersonButton}
            userId={userId}
            pastduedate={pastduedate}
        />
      </Box>
    
  </PlaningToolRoot>
}
